import { render, staticRenderFns } from "./defectSolutionPrev.vue?vue&type=template&id=2be3aac0"
import script from "./defectSolutionPrev.vue?vue&type=script&lang=js"
export * from "./defectSolutionPrev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports